import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { map, catchError } from 'rxjs/operators';

import { Router } from '@angular/router';
import { SecurityService } from '@core/Security/security.service';
import { ConfigService } from '@core/Abstract/config.service';
import { EventsEmitterService } from '@core/Abstract/emitter.service';
import { LogService } from '@core/Abstract/log.service';

@Injectable()

export class MenuService extends SecurityService{

     constructor(http:HttpClient,configService:ConfigService,eventsEmitterService: EventsEmitterService, router:Router, logger:LogService) {
        super(http,configService,eventsEmitterService, router ,logger);
    }

    getMenusForUser(langId:string): Observable<any>{
        let serviceUrl = this.baseUrl + 'MenuService/menuByPerId?'
                                      + 'langId='+langId;
        return this.http.get<any>(serviceUrl).pipe(map(
            response =>   {      
                // let body = this.parseMenus(response.json(),auth_rev == 'Y');
                let body = response;
                localStorage.setItem("menusArray_" + langId, JSON.stringify(body));
                return body;
            }
        ),catchError(super.handleError));
    }

}